import { useState } from 'react'
import { Box, VStack } from '@chakra-ui/react'

import BlotDatasetExport from '../../components/admin/BlotDatasetExport'
import { type DatasetExportFilters } from '../../api/api_hooks/admin/pilots'

/**
 * Admin — "Export" tab. Groups the data-out tools, starting with the Label
 * Studio re-training bundle, which used to sit on top of the activity table
 * and made that tab read as two unrelated things at once.
 *
 * Its filters are local here: they no longer narrow the activity table, which
 * carries its own CHU filter.
 */
export default function ExportAdmin() {
  const [filters, setFilters] = useState<DatasetExportFilters>({})

  return (
    <Box>
      <VStack spacing={5} align="stretch">
        <BlotDatasetExport filters={filters} onChange={setFilters} />
      </VStack>
    </Box>
  )
}
